import React from 'react';
import { HomefieldIconChevronRight } from '@dsg-tech/homefield-react-icons';
import { Button } from '@dsg-tech/homefield-react';
import useLogger from 'hooks/useLogger';
import CustomerServiceInfo from '../CustomerServiceInfo/CustomerServiceInfo';

interface SignedInStateProps {
  handleClickProfileMenu: () => void;
  handleKeydownProfileMenu: (event: React.KeyboardEvent) => void;
}

const SignedInState = ({
  handleClickProfileMenu,
  handleKeydownProfileMenu,
}: SignedInStateProps) => {
  const { error } = useLogger();
  const handleAuthentication = () => {
    window.authFunctions.logout().catch((e: Error) => {
      error('SignedInState', { ErrorMessage: 'Could not login user', Error: e });
    });
  };
  return (
    <>
      <div className="hmf-display-flex hmf-flex-column my-account-signed-in hmf-py-xxs hmf-px-m-xxs">
        signed in state links here
        <div
          className="hmf-px-s hmf-py-xs hmf-header-bold-m my-account-menu-item hmf-display-flex hmf-justify-content-between hmf-align-items-center"
          data-em="Header_My_Account_Profile"
          title="My Account Profile"
          aria-label="My Account Profile"
          tabIndex={0}
          role="button"
          onClick={() => handleClickProfileMenu()}
          onKeyDown={(event) => {
            handleKeydownProfileMenu(event);
          }}>
          <span>Profile</span>
          <HomefieldIconChevronRight height={20} width={20} />
        </div>
      </div>
      <div className="sign-in-button-container hmf-px-s hmf-py-xs">
        <Button
          variant="secondary"
          label="Sign out from my account"
          text="SIGN OUT"
          className="sign-in-button hmf-py-s hmf-px-l"
          onClick={() => {
            handleAuthentication();
          }}
        />
      </div>
      <CustomerServiceInfo />
    </>
  );
};

export default SignedInState;
